export default __webpack_public_path__ + "static/media/p7.73a09735.jpg";